'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _svg = require('../svg');

var _svg2 = _interopRequireDefault(_svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function GsYear(props) {
  var _classNames;

  var value = props.value,
      size = props.size,
      href = props.href,
      target = props.target,
      title = props.title,
      hasBg = props.hasBg,
      hasIcon = props.hasIcon,
      className = props.className,
      other = _objectWithoutProperties(props, ['value', 'size', 'href', 'target', 'title', 'hasBg', 'hasIcon', 'className']);

  var cls = (0, _classnames2['default'])((_classNames = {
    'icbu-icon-gs-year': true,
    'icbu-icon-gs-year-bg': hasBg
  }, _defineProperty(_classNames, 'icbu-icon-gs-year-' + size, true), _defineProperty(_classNames, 'no-icon', !hasIcon), _defineProperty(_classNames, className, className), _classNames));

  var Tag = href ? 'a' : 'span';
  var attrs = href ? { href: href, target: target, title: title } : {};

  return _react2['default'].createElement(
    Tag,
    _extends({ className: cls }, attrs, other),
    hasIcon && _react2['default'].createElement(_svg2['default'], { className: 'gs-icon', type: 'gold-supplier', size: size }),
    _react2['default'].createElement(
      'span',
      { className: 'join-year' },
      _react2['default'].createElement(
        'span',
        { className: 'value' },
        value
      ),
      _react2['default'].createElement(
        'span',
        { className: 'unit' },
        'YRS'
      )
    )
  );
}

GsYear.defaultProps = {
  value: 1,
  size: 'small',
  href: '//www.alibaba.com/help/gold_supplier.html',
  target: '_blank',
  title: 'What is Gold Supplier?',
  hasBg: true,
  hasIcon: true
};

exports['default'] = GsYear;
module.exports = exports['default'];